import { render } from "./PassList.vue?vue&type=template&id=d3a514d0&scoped=true&ts=true"
import script from "./PassList.vue?vue&type=script&lang=ts"
export * from "./PassList.vue?vue&type=script&lang=ts"

import "./PassList.vue?vue&type=style&index=0&id=d3a514d0&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3a514d0"]])

export default __exports__